import { useTranslation } from "react-i18next";
import clsx from "clsx";
import dayjs from "dayjs";
import { Calendar, EyeOff, Loader2 } from "lucide-react";
import { HighlightedText } from "components/common/HighlightedText";
import { PlanRowActionsMenu } from "../../../PlanRowActionsMenu";
import type { SidebarItemRowContentProps } from "./types";

export const SidebarItemRowContent = ({
  item,
  position,
  isSelected,
  isPending,
  isUnpublished,
  actionItems,
  normalizedSearchQuery,
}: SidebarItemRowContentProps) => {
  const { t } = useTranslation();

  return (
    <span className="flex items-start gap-2">
      <span
        className={clsx(
          "flex-shrink-0 w-5 h-5 rounded text-xs font-medium flex items-center justify-center",
          isSelected
            ? isUnpublished
              ? "bg-amber-500 text-white"
              : "bg-blue-600 text-white"
            : isUnpublished
              ? "bg-amber-200 text-amber-800"
              : "bg-gray-100 text-gray-600",
        )}
      >
        {isPending ? (
          <Loader2 size={12} className="animate-spin" />
        ) : (
          position + 1
        )}
      </span>
      <span className="break-words min-w-0 flex-1">
        {item.sourceFile && (
          <span className="block text-xs text-gray-500 leading-tight mb-0.5">
            {item.sourceFile}
          </span>
        )}
        <HighlightedText
          text={item.label}
          searchQuery={normalizedSearchQuery}
        />
        <span
          className={clsx(
            "mt-0.5 flex items-center gap-1 text-xs font-normal",
            item.isNew
              ? "text-emerald-600"
              : isUnpublished
                ? "text-amber-700"
                : isSelected
                  ? "text-blue-600"
                  : "text-gray-500",
          )}
        >
          <Calendar size={12} className="flex-shrink-0" />
          {dayjs.utc(item.createdAt).format("YYYY-MM-DD")}
        </span>
      </span>
      {isUnpublished && (
        <span
          className="flex-shrink-0 p-1 mt-0.5 text-amber-600"
          title={t("smartSurveyor.common.unpublishedPlan")}
        >
          <EyeOff size={14} />
        </span>
      )}
      {actionItems.length > 0 && (
        <PlanRowActionsMenu
          triggerTitle={t("smartSurveyor.planActions.menu")}
          items={actionItems}
        />
      )}
    </span>
  );
};
